window.EmployerEEOForm = function (scope, brandId) {

    var _formName = 'employer-eeo-form';
    var _formSelector = $('.'+_formName);

    var self = this;
    var _protected = BaseForm.call(self, _formName, scope);

    //EEO Form Data
    self.data = {};
    self.data.metadata = {};
    self.data.brand = {};

    //Doc Preview MetaData
    self.data.previewMetaData = null;

    //assign job categories
    self.data.jobCategories = EEOAPI.JOB_CATEGORIES;
    self.data.eeoTypes = EEOAPI.EEO_TYPES;

    self.TOTAL_KEY = 'TOTAL';

    //load form data
    self.load = function(){

        //load EEO Data
        EEOAPI.getBrandDocument(brandId, OnBoardingAPI.DOCUMENT_TYPE.EEO)
            .then(function(res){
                //assign metadata
                self.data.metadata = res.metadata;

                if(!self.data.metadata.values){
                    self.data.metadata.values = {};
                }

                if(!self.data.metadata.brand_id){
                    self.data.metadata.brand_id = brandId;
                }

                for(var i in self.data.jobCategories){
                    if(!self.data.metadata.values[i]){
                        self.data.metadata.values[i] = {};
                    }
                }
            }, function(res){
                //assign metadata
                self.data.metadata = {
                    values: {},
                    brand_id: brandId
                };
                for(var i in self.data.jobCategories){
                    if(!self.data.metadata.values[i]){
                        self.data.metadata.values[i] = {};
                    }
                }
            });

        //Load Profile Data
        ProfileAPI.getBrandProfile(brandId)
            .then(function(res){
                self.data.brand = res;
                //sync scope
                scope.$digest();
            }, function(res){
                console.error("die hard, the brand is not found!",res);
            });
    }

    //find totals of an array
    var syncEEOTotals = function(){

        if(!self.data.metadata.currentTotal){
            self.data.metadata.currentTotal = {};
        }

        if(!self.data.metadata.pastYearTotal){
            self.data.metadata.pastYearTotal = {};
        }

        //find totals
        for(var i in self.data.metadata.values){
            self.data.metadata.values[i][self.TOTAL_KEY] = 0;
            for(var j in self.data.metadata.values[i]){
                if(j != self.TOTAL_KEY){
                    self.data.metadata.values[i][self.TOTAL_KEY] += self.data.metadata.values[i][j];
                }
            }
        }

        self.data.metadata.currentTotal[self.TOTAL_KEY] = 0;
        for(var i in self.data.eeoTypes){
            self.data.metadata.currentTotal[i] = 0;
            for(var j in self.data.metadata.values){
                if(self.data.metadata.values[j][i]){
                    self.data.metadata.currentTotal[i] += self.data.metadata.values[j][i];
                }
            }
            //add to total sum
            self.data.metadata.currentTotal[self.TOTAL_KEY] += self.data.metadata.currentTotal[i];

        }

        self.data.metadata.pastYearTotal[self.TOTAL_KEY] = 0;
        for(var i in self.data.metadata.pastYearTotal){
            if(i != self.TOTAL_KEY){
                self.data.metadata.pastYearTotal[self.TOTAL_KEY] += self.data.metadata.pastYearTotal[i];
            }
        }
    }

    var getArrayTotal = function(arr){
        var result = 0;
        for(var i in arr){
            result += arr[i];
        }
        return result;
    }


    //save form
    self.save = function(){
        var defer = $q.defer();
        var submitBtn = _formSelector.find('#submit-btn');
        submitBtn.button('loading');

        //Find EEO Totals
        syncEEOTotals();

        //construct EEO total
        var data = self.data.metadata;

        //save it
        EEOAPI.saveBrandDocument(brandId, OnBoardingAPI.DOCUMENT_TYPE.EEO, data);

        return defer.promise;
    }


    //get Preview Data
    self.getEEOData = function(formEl){

        var metaData = angular.copy(self.data.metadata);
        if (metaData.pastYearTotal) {
            for (var i in metaData.pastYearTotal) {
                metaData.pastYearTotal[i] = metaData.pastYearTotal[i] || (metaData.pastYearTotal[i] === 0 ? 0 : '');
            }
        }
        for (var i in metaData.values) {
            for (var j in metaData.values[i]) {
                metaData.values[i][j] = metaData.values[i][j] || (metaData.values[i][j] === 0 ? 0 : '');
            }
        }

        return metaData;
    }

    //load data or init
    var init = function(){
        //load data
        self.load();
    }

    init();
};
